<template>
  <div class="overview">
    <nav-bar></nav-bar>
    <div class="content mt-4">
      <div class="row" v-if="listView">
        <div v-for="location in locations" v-bind:key="location.id" class="col-md-4 mb-4 col-12">
          <router-link :to="'/' + location.name" :class="'anchor-card'">
            <location
              :name="location.name"
              :country="location.country"
              :lastUpdate="location.lastUpdate"
              :lastInput="location.lastInput"
              :timezone="location.timezone"
              :image="location.thumbnail"
            />
          </router-link>
        </div>
      </div>
    </div>
    <copyright></copyright>
  </div>
</template>

<script>
import Navbar from "./parts/nav";
import LocationOverview from "./parts/location-overview";
import Footer from "./parts/footer";

let data = {
  listView: true,
  locations: {},
  selectedLocation: {}
};

export default {
  name: "Overview",
  components: {
    "nav-bar": Navbar,
    location: LocationOverview,
    copyright: Footer
  },
  mounted: function() {
    // replace this with API call to get a list of cities and basic details
    let data = require("../cities.json");
    this.locations = data.locations;
  },
  data: function() {
    return data;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
  padding: 0 20px;
  margin-bottom: 50px;
}

a.anchor-card {
  color: #001d3e;
  text-decoration: none;
}
</style>
